(function($) {
	$('ul.announcements-filter > li').on('click', function(e) {
		// Set the button as active
		$(this).addClass('active');
		$(this).siblings().removeClass('active');

		// Set the selected section as active
		const targetClass = $(e.target).data('target');

		// Find the number of active items
		const totalItems = $('.announcements-section > .announcement-item').length;

		if ( targetClass === '*' ) {
			$('.announcements-section > .announcement-item').addClass('active').delay(2500).show();
			// $(`.announcements-section > .announcement-item`).slideDown('slow').show('slow');
			$('.announcements-count').text(`Visar alla ${totalItems} inlägg`);
		} else {

			$(`.announcements-section > .announcement-item.${targetClass}`).siblings().removeClass('active').delay(2500).hide();
			$(`.announcements-section > .announcement-item.${targetClass}`).each(function () {
				$(this).addClass('active').delay(2500).show();
			});
			// $(`.announcements-section > .announcement-item.${targetClass}`).slideDown('slow').show('slow').siblings().slideUp('slow').hide('slow');
			const activeItems = $('.announcements-section > .announcement-item.active').length;
			$('.announcements-count').text(`Visar ${activeItems} av ${totalItems} inlägg`);
		}
	});
})(jQuery);